/**
 * 첫 결제 혜택의 글자 — 무료 달 · 혜택 알약 · 「지금 결제하면 무료 한달 추가」(요금·결제 화면이 쓴다).
 * 순수 함수다 — `'use client'` 를 붙이지 않는다.
 */

import type { PaymentBonusType } from './plan-period';

/** 체험 중 결제로 더 받는 무료 기간 — 「무료 한달」(1이면 「한달」, 그 밖에는 「N달」). 남은 일수는 싣지 않는다. */
export function trialBonusText(bonusMonths: number): string {
  return `무료 ${bonusMonths === 1 ? '한달' : `${bonusMonths}달`}`;
}

/**
 * 혜택 알약 — 까닭(체험 중 · 만료 뒤 …)과 무관하게 「특별 프로모션」 하나다. 까닭이 늘어도 같은 말을 쓴다.
 * @param _type 혜택 까닭 — 지금은 알약 글자를 가르지 않는다
 */
export function paymentBonusBadge(_type: PaymentBonusType): string {
  return PAYMENT_BONUS_BADGE;
}

/** 첫 결제 혜택 알약 글자 */
const PAYMENT_BONUS_BADGE = '특별 프로모션';

/** 체험 중 결제 혜택 한 줄 — 「지금 결제하면 무료 한달 추가」. 요금 화면 혜택 카드가 쓴다(남은 일수는 싣지 않는다). */
export function trialOfferTitle(bonusMonths: number): string {
  return `지금 결제하면 ${trialBonusText(bonusMonths)} 추가`;
}
